// initial state
// shape: [{ id, quantity }]
const state = {}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getDepartmentsIndex: ({commit, state}, params) => request.alert('getDepartmentsIndex', params),
  getAllDepartments: ({commit, state}, params) => request.alert('getAllDepartments', params),
  getDepartmentDetail: ({commit, state}, params) => request.alert('getDepartmentDetail', params),
  addDepartment: ({commit, state}, params) => request.alert('addDepartment', params),
  editDepartment: ({commit, state}, params) => request.alert('editDepartment', params),
  deleteDepartment: ({commit, state}, params) => request.alert('deleteDepartment', params),
}

// mutations
const mutations = {}

export const platformDepartment = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/platform-department/platform-department.store.js